import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import ProfileCard from "../../components/ProfileView/ProfileCard";

import { setPage, setTrTab } from "../../state/slices/generalSlice";

import { Row, Col, Alert } from "antd";

import "../../styles/pages/homePage/homePage.scss";
import OuLinks from "./components/OuLinks";
import EbulletinQuickLinks from "./components/EbulletinQuickLinks";
import DocReqQuickLink from "./components/DocReqQuickLink";
import { renderStatus } from "../../utils/generalUtils";
import PvCardList from "../../components/DataView/PvCardList";
import ViewingFormButton from "../../components/Form/ViewingFormButton";
import { trlConfig } from "../../components/BaseDocumentRequest/config/trlConfig";
import { cosConfig } from "../../components/BaseDocumentRequest/config/cosConfig";

const HomePage = () => {
  const dispatch = useDispatch();

  const { details, latest_trl, latest_cos } = useSelector(
    (state) => state.accountDetailSlice
  );

  const [previewItem, setPreviewItem] = useState(null);
  const [previewViewingDataConfig, setPreviewViewingDataConfig] = useState([]);
  const isEmployeeInactive = details?.is_active === false;

  const baseUrl = process.env.REACT_APP_API_URL?.replace(/\/api$/, "") ?? "http://localhost:8000";
  const profilePhotoUrl = details?.profile_photo
    ? details.profile_photo.startsWith("http")
      ? details.profile_photo
      : `${baseUrl}${details.profile_photo}`
    : null;

  const updatedLatestTrl = latest_trl?.map((item) => ({
    start_date: item?.travel_request_local?.start_date,
    end_date: item?.travel_request_local?.end_date,
    destination: item?.travel_request_local?.destination,
    purpose: item?.travel_request_local?.purpose,
    expenses: item?.travel_request_local?.expenses,
    funding_source: item?.travel_request_local?.funding_sourse,
    local_travel_transportation: item?.travel_request_local?.local_travel_transportation,
    entitlement: item?.travel_request_local?.entitlement,
    ...item,
    submission_date: item?.created_at ? new Date(item.created_at).toLocaleString() : null,
  }));

  const updatedLatestCos = latest_cos?.map((item) => ({
    start_date: item?.certificate_of_service?.start_date,
    end_date: item?.certificate_of_service?.end_date,
    absent: item?.certificate_of_service?.absent,
    act1: item?.certificate_of_service?.act1,
    week1_hours: item?.certificate_of_service?.week1_hours,
    act2: item?.certificate_of_service?.act2,
    week2_hours: item?.certificate_of_service?.week2_hours,
    act3: item?.certificate_of_service?.act3,
    week3_hours: item?.certificate_of_service?.week3_hours,
    act4: item?.certificate_of_service?.act4,
    week4_hours: item?.certificate_of_service?.week4_hours,
    act5: item?.certificate_of_service?.act5,
    week5_hours: item?.certificate_of_service?.week5_hours,
    ...item,
    submission_date: item?.created_at ? new Date(item.created_at).toLocaleString() : null,
  }));

  const openPreview = (item, viewingDataConfig) => {
    setPreviewItem(item);
    setPreviewViewingDataConfig(viewingDataConfig);
  };

  const closePreview = () => {
    setPreviewItem(null);
  };

  const cosCols = [
    { title: "Start Date", dataIndex: "start_date", key: "start_date" },
    { title: "End Date", dataIndex: "end_date", key: "end_date" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: renderStatus(
        ["pending"],
        ["approved"],
        ["disapproved", "denied"]
      ),
    },
    {
      title: "Date Submitted",
      dataIndex: "submission_date",
      key: "submission_date",
    },
  ];

  const trlCols = [
    // { title: "Destination", dataIndex: "destination", key: "destination" },
    { title: "Start Date", dataIndex: "start_date", key: "start_date" },
    { title: "End Date", dataIndex: "end_date", key: "end_date" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: renderStatus(
        ["pending"],
        ["approved"],
        ["disapproved", "denied"]
      ),
    },
    {
      title: "Date Submitted",
      dataIndex: "submission_date",
      key: "submission_date",
    },
  ];

  function handleNavigation(page, subPage) {
    if (!page) return;
    dispatch(setPage(page));
    if (subPage) {
      dispatch(setTrTab(subPage));
    }
  }

  return (
    <div className="home-page">
      <div className="profile-container">
        <ProfileCard name={details?.first_name ? `${details.first_name} ${details.last_name}` : details?.email} image={profilePhotoUrl} />
      </div>

      <div className="shell">
        <div className="home-shell-content">
          <Row gutter={[16, 16]} className="grid-row">
            <Col xs={0} md={10}>
              <OuLinks />
            </Col>

            <Col xs={24} md={14}>
              <Row gutter={[16, 16]} className="content-row">
                <Col span={24}>
                  <EbulletinQuickLinks />
                </Col>
                <Col xs={24} sm={12}>
                  <DocReqQuickLink
                    cardTitle="Latest Travel Request"
                    children={
                      <PvCardList
                        data={updatedLatestTrl}
                        maxActiveRow={1}
                        columns={trlCols}
                        onRowClick={(item) => openPreview(item, trlConfig.viewingDataConfig)}
                        showPagination={false}
                      />
                    }
                    onQuickLink={() => handleNavigation("doc-req", "tr-local")}
                  />
                </Col>
                <Col xs={24} sm={12}>
                  <DocReqQuickLink
                    cardTitle="Latest Certificate of Service"
                    children={
                      <PvCardList
                        data={updatedLatestCos}
                        maxActiveRow={1}
                        columns={cosCols}
                        onRowClick={(item) => openPreview(item, cosConfig.viewingDataConfig)}
                        showPagination={false}
                      />
                    }
                    onQuickLink={() => handleNavigation("doc-req", "cos")}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

        {isEmployeeInactive && (
          <div className="home-lock-overlay">
            <Alert
              type="warning"
              showIcon
              message="Please contact HR if you want to access PIVOT."
            />
          </div>
        )}
      </div>

      <ViewingFormButton
        hideTrigger
        open={!!previewItem}
        onOpenChange={(open) => !open && closePreview()}
        contents={previewItem || {}}
        viewingDataConfig={previewViewingDataConfig}
      />
    </div>
  );
};

export default HomePage;
